<template>
	<div>
    <b-sidebar id="sidebar-right-stock" :title="symbol_name" :width="sidebarWidth" backdrop :right="placement==='right'" shadow @shown="onSidebarShown">
            <template #title>
                <div class="d-flex align-items-center">
                    <div class="mr-2">{{ symbol_name }}</div>
                    <span class="text-muted small mr-2">{{ symbol_code }}</span>
                    <b-button v-if="viewportWidth > 768" size="sm" variant="secondary" class="ml-auto mr-2" @click="toggleFullscreen">{{ isFullscreen ? '退出全屏' : '全屏' }}</b-button>
                    <b-button size="sm" variant="outline-secondary" @click="togglePlacement">{{ placement==='right' ? '左侧' : '右侧' }}</b-button>
                </div>
            </template>
            <div class="calendar-container p-2 border-bottom">
				<div class="d-flex align-items-center">
					<label class="mb-0 mr-2">日期</label>
					<b-form-datepicker
						id="datepicker"
						ref="datepicker"
						v-model="localDateMark"
						:min="minDate"
						:max="maxDate"
						locale="zh"
						size="sm"
						today-button
						reset-button
						close-button
						@input="onDateChange"
						class="mr-2"
						style="width: 200px;"
					></b-form-datepicker>
            <b-button size="sm" variant="primary" class="ml-2" @click="setToday">今天</b-button>
            </div>
            </div>
			<div>
				<StockUpLimitReason :symbol_code="symbol_code" :date_mark="localDateMark"></StockUpLimitReason>
			</div>
		<div class="border">
			<b-form-checkbox
			id="status_popular"
			v-model.number="status_popular"
			name="status_popular"
			value="1"
			unchecked-value="0">
			人气
			</b-form-checkbox>
		</div>
        
			<div v-if="!is_show_popular" class="m-l-5">
				<StockKlineDay :chart_width="chart_width" :chart_heigh="chart_heigh" :chart_rank_line="chart_rank_line" :symbol_code="symbol_code" :highlightDate="date_mark" :title="symbol_code" :subText="symbol_name" @date-selected="onDateSelected"></StockKlineDay>
			</div>
			<div v-if="is_show_popular" class="m-l-5">
				<StockKlineWithPopular :chart_width="chart_width" :chart_heigh="chart_heigh" :chart_rank_line="chart_rank_line" :symbol_code="symbol_code" :highlightDate="date_mark" :title="symbol_code" :subText="symbol_name" @date-selected="onDateSelected"></StockKlineWithPopular>
			</div>
            <div class="m-l-5">
                <StockTrend :key="symbol_code + ':' + (selected_date||'') + ':' + status_popular + ':' + sidebarShownTick" :chart_width="chart_width" :chart_heigh="chart_heigh" :symbol_code="symbol_code" :title="symbol_name" :subText="symbol_code" :selected_date="selected_date"></StockTrend>
            </div>
			<div>
				<StockPlates :symbol_code="symbol_code"></StockPlates>
			</div>
			<div class="clearfix"></div>
			
		</b-sidebar>
	</div>
</template>

<script>
	import StockKlineWithPopular from 'components/stock/StockKlineWithPopular.vue'
	import StockKlineDay from 'components/stock/StockKlineDay.vue'
	import StockTrend from 'components/stock/StockTrend.vue'
	import StockPlates from 'components/stock/StockPlates.vue'
import StockUpLimitReason from 'components/stock/StockUpLimitReason.vue'
export default {
		props: {
			symbol_code: String,
			symbol_name: String,
			date_mark: String,
		},
    computed:{
        is_show_popular(){
            return new Number(this.status_popular)==1;
        },
        sidebarWidth(){ return this.isFullscreen ? '100vw' : ((this.viewportWidth <= 768) ? '100vw' : '40vw') }
    },
	data() {
        return {
            status_popular:0,
            colorblind: false,
            chart_rank_line:{width: 1,opacity: 0.3,color: '#E69F00'},
            chart_width:'100%',
            chart_heigh:'350px',
            selected_date: '', // 存储选中的日期
            localDateMark: this.date_mark, // 本地日期，初始值为props中的date_mark
            minDate: '2010-01-01', // 日历最小日期
            maxDate: new Date().toISOString().split('T')[0], // 日历最大日期为今天
            viewportWidth: 1024,
            isFullscreen: false
            ,sidebarShownTick: 0
            ,placement: 'left'
        };
    },
    mounted(){
        const c = localStorage.getItem('site.colorblind');
        if(c){ this.colorblind = (c==='1' || c==='true') }
        const p = localStorage.getItem('site.sidebarPlacement');
        if(p) { this.placement = p; }
        this.chart_rank_line.color = this.colorblind ? '#E69F00' : '#ec0000'
        this.viewportWidth = window.innerWidth || 1024
        this._onResize = () => { this.viewportWidth = window.innerWidth || this.viewportWidth }
        window.addEventListener('resize', this._onResize)
    },
    beforeDestroy(){ if(this._onResize) { window.removeEventListener('resize', this._onResize) } },
		watch: {
			// 监听props中date_mark的变化，同步到本地变量
			date_mark(newVal) {
				this.localDateMark = newVal;
				// 当date_mark变化时，同步更新selected_date
				this.selected_date = newVal;
			}
		},
        methods: {
            onDateSelected(date) {
                this.selected_date = date;
                // 格式化日期为YYYY-MM-DD格式，用于日历显示
                const formattedDate = date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
                // 直接更新v-model绑定的值，而不是通过ref操作
                this.localDateMark = formattedDate;
            },
			// 日期变化时触发事件
			onDateChange(date) {
				this.selected_date = date;
				this.localDateMark = date; // 同步更新localDateMark
				// 触发自定义事件，通知父组件date_mark已变化
				this.$emit('date-mark-change', date);
			},
			// 快捷：设置为今天
            setToday() {
                const today = this.maxDate; // 已定义为今天的YYYY-MM-DD
                this.onDateChange(today);
            },
            toggleFullscreen(){ this.isFullscreen = !this.isFullscreen }
            ,onSidebarShown(){ this.sidebarShownTick++; }
            ,togglePlacement() {
                this.placement = this.placement === 'left' ? 'right' : 'left';
                localStorage.setItem('site.sidebarPlacement', this.placement);
            }
        },
        components:{
            StockKlineWithPopular,
            StockKlineDay,
            StockTrend,
            StockPlates,
            StockUpLimitReason
        },
    }
</script>

<style>
</style>
